module.exports = __webpack_public_path__ + "dist/assets/img/scrum.5c2a1ef0.svg";